import React, { Component } from "react";
import Landing from "./LandingContainer";
import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";

class CreateFenomeneContainer extends Component {
  render() {
    return (
      <Landing history={this.props.history} hasFooter={true}>
        <div>
          <h1 className="page-title">{LANDING_MENU_BAR.CREATE_FONEMENES}</h1>
        </div>
      </Landing>
    );
  }
}

export default CreateFenomeneContainer;
